import { Injectable } from '@angular/core';
import { CountryCode } from '~shared/constants';

@Injectable({
  providedIn: 'root',
})
export class FlixMediaBrandPageService {
  flixMediaBrandPageEnabledCountriesList = [CountryCode.Germany];

  constructor() {}

  getFlixMediaBrandPageForCountry(countryCode: CountryCode): boolean {
    return this.flixMediaBrandPageEnabledCountriesList.includes(countryCode);
  }
}
